// extracted by mini-css-extract-plugin
export default {"gridRoot":"CharactersGrid_gridRoot__6rqpy","gridItem":"CharactersGrid_gridItem__e3YKc","card":"CharactersGrid_card__oOXQG","emptyLoading":"CharactersGrid_emptyLoading__cVb5t"};